import { FunctionComponent } from "react";

interface OnboardingStepDotsProps {
	/** 1-based index of the step the user is currently on. */
	currentStep: number;
	/** Total number of steps in the onboarding funnel. */
	totalSteps?: number;
}

/**
 * The signup → profile → chat → lists progress indicator shown at the bottom of
 * the onboarding cards. On the public register page only step 1 is active; the
 * remaining steps happen inside the app after signup, so they render as future.
 */
export const OnboardingStepDots: FunctionComponent<OnboardingStepDotsProps> = ({
	currentStep,
	totalSteps = 4,
}) => {
	const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

	return (
		<div className="flex items-center justify-center">
			{steps.map((step) => {
				const isDone = step < currentStep;
				const isActive = step === currentStep;

				return (
					<div className="flex items-center" key={step}>
						<div
							className={[
								"flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold",
								isDone && "bg-blue-action text-white",
								isActive && "bg-blue-action text-white ring-4 ring-blue-action/15",
								!isDone && !isActive && "text-text-meta",
							]
								.filter(Boolean)
								.join(" ")}
						>
							{isDone ? "✓" : step}
						</div>
						{step < totalSteps && (
							<div
								className={`mx-1 h-[2.5px] w-12 rounded ${
									step < currentStep ? "bg-blue-action" : "bg-gray-200"
								}`}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};
